module.exports = __webpack_public_path__ + "img/Search.1d1aa9e4.svg";